// 学习记录
import global_ from "../global/index"
import '../../static/js/jquery.md5.js'

let serverurl = "";
if (process.env.NODE_ENV=='development') {
    serverurl = global_.global.record_local + '/learning-record/open/pub?ak=71f388fb7ce4b22eea79a03a4b524183&t='+parseInt(new Date().getTime()/1000)+'&sign='+$.md5('ak=71f388fb7ce4b22eea79a03a4b524183&t='+parseInt(new Date().getTime()/1000)+'&sk=d19889162def5120d50a94283f7ebb58');
} else if (process.env.NODE_ENV=='testing') {
    serverurl = global_.global.record_test_url + '/learning-record/open/pub?ak=71f388fb7ce4b22eea79a03a4b524183&t='+parseInt(new Date().getTime()/1000)+'&sign='+$.md5('ak=71f388fb7ce4b22eea79a03a4b524183&t='+parseInt(new Date().getTime()/1000)+'&sk=d19889162def5120d50a94283f7ebb58');
} else {
  serverurl = global_.global.record_online_url + '/learning-record/open/pub?ak=9dfbae3ed9a3019ffefd28c5a225ef9a&t='+parseInt(new Date().getTime()/1000)+'&sign='+$.md5('ak=9dfbae3ed9a3019ffefd28c5a225ef9a&t='+parseInt(new Date().getTime()/1000)+'&sk=94ecd058cfc318d8640074d27f672497');
}

let finalParams = {
    platform: 'h5',
    system: navigator.userAgent,
    user_id: 0
};
const handleClassRecord = (params) => {
    if(localStorage.getItem("ticketObj")) {
        finalParams.sso_id = JSON.parse(localStorage.getItem("ticketObj")).sso_id
    } else {
        finalParams.sso_id = params.sso_id
    }
    finalParams.appid = params.appid
    finalParams.erp_id = params.erp_id
    finalParams.cid = params.cid
    finalParams.package_id = params.package_id
    finalParams.unit_id = params.unit_id
    finalParams.course_id = params.course_id
    finalParams.final_id = params.final_id
    finalParams.action_time = params.action_time
    finalParams.start_time = params.start_time
    finalParams.product = params.product
    finalParams.action = params.action
    finalParams.is_online = params.is_online
    finalParams.module_type = params.module_type
    finalParams.course_type = params.course_type
    finalParams.version = params.version
    finalParams.live_type = params.live_type
    finalParams.room_id = params.room_id
    finalParams.current_position = params.current_position
    finalParams.length = params.length
    finalParams.other = params.other
    if (params.total_length) {
        finalParams.total_length = params.total_length
    }
    $.ajax({
        url: serverurl,
        type: 'post',
        data: JSON.stringify(finalParams),
        success:function (res) {
            console.log(res)
        }
    })
}

export default handleClassRecord;



// WEBPACK FOOTER //
// ./src/utils/record.js